module.exports = __webpack_public_path__ + "img/sub-report-directory.f854d2f1.png";